import { useTranslation } from "@i18n/hooks";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { OfferFilesTable } from "../../features/offer-files/offer-files-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const OfferFilesScreen = () => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions("onlyOwnerOfRoot");

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("offerFiles.screenTitle")}>
			<OfferFilesTable canUploadFiles={true} canDeleteFiles={true} />
		</BaseScreen>
	);
};
